import { AuthGroup, AuthUtil, PiaUser } from './auth.types'

export class PermissionChecker {
  private groups: AuthGroup[]

  constructor(groups: AuthGroup[] = []) {
    this.groups = groups
  }

  hasGroup(group: AuthGroup): boolean {
    return this.groups.includes(group)
  }

  hasAnyGroup(groups: AuthGroup[]): boolean {
    return groups.some((group) => this.hasGroup(group))
  }
}

export const auth = (user: PiaUser | undefined): AuthUtil => {
  const checker = new PermissionChecker(user?.groups ?? [])
  const isAdmin = checker.hasGroup(AuthGroup.ADMIN)
  const isCops = checker.hasGroup(AuthGroup.COPS)
  const isReadonly = checker.hasGroup(AuthGroup.READONLY)
  const userLoggedInWithPia = user?.userLoggedInWithPia ?? false
  const canPerformActions = !userLoggedInWithPia || isAdmin || isCops

  return {
    user,
    userLoggedInWithPia,
    isAdmin,
    isCops,
    isReadonly,
    canPerformActions,
  }
}
